export type BrowserNotificationState = "default" | "granted" | "denied" | "unsupported"

function isSupported() {
  return typeof window !== "undefined" && "Notification" in window
}

export function getBrowserNotificationState(): BrowserNotificationState {
  if (!isSupported()) return "unsupported"
  return Notification.permission
}

async function getNotificationRegistration() {
  if (!("serviceWorker" in navigator)) return null
  return navigator.serviceWorker.register("/notification-sw.20260909-0954.js", { scope: "/" })
}

async function showNotification(title: string, options: NotificationOptions) {
  if (getBrowserNotificationState() !== "granted") return false

  const registration = await getNotificationRegistration().catch(() => null)
  if (registration) {
    await registration.showNotification(title, options)
    return true
  }

  // Desktop browsers without service-worker support can still display a
  // notification while the page is open.
  new Notification(title, options)
  return true
}

export async function enableBrowserNotifications(): Promise<BrowserNotificationState> {
  if (!isSupported()) return "unsupported"
  const permission = Notification.permission === "default"
    ? await Notification.requestPermission()
    : Notification.permission

  if (permission === "granted") {
    await showNotification("Уведомления включены", {
      body: "Сообщим, когда закончится фокус.",
      icon: "/assets/pomesto_app_icon_192.png",
      badge: "/assets/pomesto_app_icon_192.png",
      tag: "pomesto-notifications-enabled",
    }).catch(() => false)
  }
  return permission
}

export async function prepareBrowserNotifications() {
  if (getBrowserNotificationState() === "granted") {
    await getNotificationRegistration().catch(() => null)
  }
}

export async function showFocusCompleteNotification(minutes: number) {
  return showNotification("Фокус завершён", {
    body: `Готово: ${minutes} мин в фокусе. Можно немного отдохнуть.`,
    icon: "/assets/pomesto_app_icon_192.png",
    badge: "/assets/pomesto_app_icon_192.png",
    tag: "pomesto-focus-complete",
  }).catch(() => false)
}

export async function showBreakCompleteNotification() {
  return showNotification("Перерыв закончен", {
    body: "Пора вернуться к своему делу.",
    icon: "/assets/pomesto_app_icon_192.png",
    badge: "/assets/pomesto_app_icon_192.png",
    tag: "pomesto-break-complete",
  }).catch(() => false)
}
